export default "__VITE_ASSET__72cbf9c8__"